{{#TEMPLATE ctx 'name'}}
	<i class="fa {{#if model.is_active}}fa-bell success{{else}}fa-bell-slash error{{/if}}"></i>
	<a id="cfg-alarm-{{model.id}}" data-idx="{{model.id}}" href="#" class="js-configure-alarm">
	{{model.name}}
	</a>
	<br>
	<small>{{TR 'Priorität'}}: {{priority_text}}</small>
{{/TEMPLATE}}

{{#TEMPLATE ctx 'condition'}}
{{#each this}}
	{{text}}{{#if items}}:{{/if}}<br>
	{{#each items}}
	&#8226;&nbsp;{{this}}<br>
	{{/each}}
{{/each}}
{{/TEMPLATE}}

{{#TEMPLATE ctx 'trigger'}}
	{{time}}{{#if model.notify_corrected}} {{TR 'und bei Beseitigung der Fehler'}}{{/if}}<br>
	{{#if model.send_list}}
		<strong>{{TR 'Benachrichtigung an Postfach'}}:</strong><br>
		{{#each model.send_list}}
			{{name}}<br>
		{{/each}}
	{{else}}
	{{TR 'Benachrichtigung'}}:
	{{#LIST ', '}}
		{{#LI}}{{#if model.send_email}}{{TR 'per E-Mail'}}{{/if}}{{/LI}}
		{{#LI}}{{#if model.send_sms}}{{TR 'per SMS'}}{{/if}}{{/LI}}
		{{else}}
		--
	{{/LIST}}
	{{/if}}
{{/TEMPLATE}}
